"use client";
import React, { InputHTMLAttributes, useState, ReactNode, forwardRef } from "react";
import { useGlobalContext } from "@/contexts/AppContext";
import styles from "./InputField.module.scss";
import EyeCloseIcon from "../svgs/jsx/EyeClose";
import EyeOpenIcon from "../svgs/jsx/EyeOpen";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	name?: string;
	label?: string;
	isPassword?: boolean;
	className?: string;
	inputClass?: string;
	wrapperClassName?: string;
	customPrefix?: any;
	suffix?: React.JSX.Element;
	inputRef?: any;
	register?: any;
	autoComplete?: string;
	value?: any;
	suffixClass?: string;
	isNonModal?: boolean;
	forceLightIcon?: boolean;
	isCheckout?: boolean;
	bg?: "dark" | "light";
}

const InputField = forwardRef<HTMLInputElement, Props>(
	(
		{
			name,
			type = "text",
			label,
			className,
			value,
			suffixClass,
			inputClass,
			customPrefix,
			wrapperClassName,
			isPassword,
			suffix,
			register,
			autoComplete,
			isNonModal,
			forceLightIcon = false,
			isCheckout = false,
			bg,
			...options
		},
		ref
	) => {
		const [inputType, setInputType] = useState<string>(type);
		const handleShowPassword = () => {
			if (inputType === "password") {
				setInputType("text");
			}
			if (inputType === "text") {
				setInputType("password");
			}
		};
		const { theme } = useGlobalContext();
		const iconTheme = forceLightIcon ? "light" : theme;

		return (
			<div data-theme={theme} className={`${styles.input} ${className}`}>
				{!!label && (
					<label
						className={`${styles.input_label} ${
							isCheckout && theme === "dark" ? styles.checkout_label : ""
						}`}
						htmlFor={name}
					>
						{label}
					</label>
				)}

				<div
					data-theme={theme}
					data-bg={bg}
					className={`${styles.input_wrapper} ${wrapperClassName || ""}`}
				>
					{customPrefix && <h6>{customPrefix}</h6>}

					<input
						value={value}
						className={`${inputClass} ${styles.input_field} ${
							isNonModal ? styles.non_modal_input : ""
						}`}
						type={inputType}
						ref={ref}
						{...register}
						{...options}
						autoComplete="off"
						data-theme={theme}
						data-bg={bg}
					/>

					{isPassword && (
						<div className={styles.icon} onClick={handleShowPassword}>
							{inputType === "password" ? (
								<EyeCloseIcon theme={iconTheme} />
							) : (
								<EyeOpenIcon theme={iconTheme} />
							)}
						</div>
					)}

					{suffix && (
						<div
							className={`${styles.suffixClass} ${styles.suffix_container}`}
						>
							{suffix && <>{suffix}</>}
						</div>
					)}
				</div>
			</div>
		);
	}
);

InputField.displayName = "InputField";

export default InputField;
